import { StudentProblemResult, LessonProblem } from '@yandex-int/k-common/typings';
import React from 'react';
import { useSelector } from 'react-redux';

import { getIsCustomFlowLesson } from 'common.components/lesson/selectors';

import { CommonAttemptsText } from '../_student-attempts-text/common-attempts-text';
import { CustomFlowLessonAttemptsText } from '../_student-attempts-text/custom-flow-lesson-attempts-text';

export interface StudentAttemptsTextProps {
    studentProblemResult: StudentProblemResult | null;
    problemLink: LessonProblem;
}

export const useStudentAttemptsText = () => {
    const isCustomFlowLesson = useSelector(getIsCustomFlowLesson);

    if (isCustomFlowLesson) {
        return (props: StudentAttemptsTextProps) => (
            <CustomFlowLessonAttemptsText studentProblemResult={props.studentProblemResult} />
        );
    }

    return (props: StudentAttemptsTextProps) => (
        <CommonAttemptsText problemLink={props.problemLink} studentProblemResult={props.studentProblemResult} />
    );
};
